import Backbone from 'backbone';

import ParseService from '~/services/parseService';
import Model from '~/models/parseModel';
import Collection from '~/collections/parseCollection';
import toastr from 'toastr';

/**
 * @member [reportCommentsService] reportCommentsService
 */
var reportReasonOfChangeStatusService;

/**
 * Object Picture service, manages pictures
 * @module services/reportCommentsService
 * @returns [reportCommentsService]
 */

export default function () {

    /**
     * Assigns ReportComments class with properties
     * @member [ReportComments] ReportCommentsModel
     */
    var ReasonOfChangeStatusModel = Model.extend({
        className: "ReasonOfChangeStatus",
        defaults: {
            'manualTitle': false,
        }
    });

    /**
     * Represents a collection of ReportComments
     * @member [ReportComments collection] ReportCommentCollection
     */
    var ReasonOfChangeStatusCollection = Collection.extend({
        model: ReasonOfChangeStatusModel
    });

    /**
     * it's ReportCommentsModel service, object type service of the collection
     * @member [ReportComments Service] ReportCommentsService
     */
    var ReasonOfChangeStatusService = ParseService.extend({
        sortBy: 'createdAt',
        order: 'dsc',
        model: ReasonOfChangeStatusModel,
        collection: ReasonOfChangeStatusCollection,
		setReasonOfChangeStatus:function(report, reasonofchange, xl){
			var vReasonOfChangeStatus = Parse.Object.extend("ReasonOfChangeStatus");
			var varReasonOfChangeStatus = new vReasonOfChangeStatus();
			varReasonOfChangeStatus.set("report",report);
			varReasonOfChangeStatus.set("reason",reasonofchange);
			varReasonOfChangeStatus.save(null, {
				success: function(varReasonOfChangeStatus) {
					xl(varReasonOfChangeStatus);
				},
				error: function(varReasonOfChangeStatus, error) {
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'], 'Error');
						break;
                        default:
							if(arrlang[lang][error.message]){
								toastr.error(arrlang[lang][error.message], "Error");
							}
							else{
								toastr.warning(arrlang[lang]['messagetochangestatus3'], "Advertencia");
							}
						break;
					}
				}
			});
		},
        // you can also extend any method from ParseService here
    });

    return reportReasonOfChangeStatusService || (reportReasonOfChangeStatusService = new ReasonOfChangeStatusService());
};
// only created once for application
